import Vue from 'vue'
import loader from '@/loader'
import { mapGetters } from 'vuex'
import '../../node_modules/noty/src/noty.scss'
import '../../node_modules/noty/src/themes/sunset.scss'

// import intlTelInput from 'intl-tel-input'
import sanitizeHtml from "sanitize-html";
import VueLazyload from "vue-lazyload";

// global.intlTelInput = intlTelInput

Vue.prototype.sanitize = (dirty => {
    return sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img'])
    })
})

Vue.use(VueLazyload, {
    preLoad: 4,
})


import { GET_TEXTS } from '@/store/actions.type'

import {
    SET_CLIENT_INFO,
    SET_CONTACTLESS_MODE,
    SET_CONTAINER,
    SET_QUERY_PARAMS,
    SET_TIME,
    SET_WEBVIEW_GUARD
} from '@/store/mutations.type'

export const appMixin = {
    data: () => ({
        css_direction: loader.css_direction
    }),
    computed: {
        ...mapGetters(['webviewGuard', 'gtmTag'])
    },
    methods: {
        async initApp() {
            let urlParams = new URLSearchParams(window.location.search)
            await this.$store.commit(SET_QUERY_PARAMS, btoa(JSON.stringify({
                t: urlParams.get('t')
            })))
            let contactlessMode
            if (urlParams.get('t')) {
                contactlessMode = true
                this.$store.commit(SET_CONTACTLESS_MODE, true)
            }

            let webp = await this.checkWebpFeature('lossy', function(feature, isSupported) {
                if (isSupported) {
                    let sBrowser, sUsrAg = navigator.userAgent
                    if (sUsrAg.indexOf("Safari") > -1) {
                        sBrowser = "Apple Safari";
                    } else {
                        sBrowser = "unknown";
                    }
                    if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) && window.innerWidth < 376 || sBrowser === 'Apple Safari') {
                        webp = false
                    } else {
                        webp = true
                    }
                }
            })

            let clientInfo = {
                browserWidth: window.innerWidth,
                browserHeight: window.innerHeight,
                webpSupport: webp
            }
            this.$store.commit(SET_CLIENT_INFO, JSON.stringify(clientInfo))
                // this.$store.commit(SET_WEBVIEW_GUARD, true);
            if (token === process.env.VUE_APP_WEB_TOKEN && !contactlessMode) {
                this.$store.commit(SET_WEBVIEW_GUARD, true)
            } else {
                this.$store.commit(SET_WEBVIEW_GUARD, false)
            }

            this.$store.dispatch(GET_TEXTS)
        },
        checkWebpFeature(feature) {
            return new Promise((resolve, reject) => {
                var kTestImages = {
                    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA'
                }
                var img = new Image()
                img.onload = function() {
                    var result = img.width > 0 && img.height > 0
                    resolve(result)
                }
                img.onerror = function() {
                    resolve(false)
                }
                img.src = 'data:image/webp;base64,' + kTestImages[feature]
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (window.location.search.substring(0, 7) === '?random' && window.self !== window.top) {
                parent.postMessage('dgsnWidget.close', '*')
            }

            const _this = this
            window.extAsyncInit = function() {
                if (MessengerExtensions.isInExtension()) {
                    return _this.$store.commit(SET_CONTAINER, _this.$store.getters.const.CONTAINER_FACEBOOK)
                }
                if (window.self !== window.top) {
                    return _this.$store.commit(SET_CONTAINER, _this.$store.getters.const.CONTAINER_IFRAME)
                }
                return _this.$store.commit(SET_CONTAINER, _this.$store.getters.const.CONTAINER_TAB)
            }

            setInterval(() => {
                this.$store.commit(SET_TIME)
            }, 1000 * 60)
        })
    },
    watch: {
        async webviewGuard(webviewGuard) {
            if (webviewGuard === false) {
                this.startWebview()
            } else {
                this.$router.push({
                    name: 'guard',
                    params: { token: this.$store.getters.token }
                })
            }
        }
    }
}